function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Lunacy");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group-2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(12.594727 2.28125)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.40537 7.8345L6.40537 0L0 3.99825L6.40537 7.8345Z",
  id: "Vector",
  fill: "#FFD300",
  fillRule: "evenodd",
  stroke: "none"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(0 2.28125)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 7.8345L6.40538 3.99825L0 0L0 7.8345Z",
  id: "Vector",
  fill: "#FFD300",
  fillRule: "evenodd",
  stroke: "none"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(0.03515625 0)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.15188 0C0.559313 0 0.0890625 0.4185 0 0.957375L9.46437 6.86475L18.9288 0.957375C18.8397 0.4185 18.3694 0 17.7769 0L1.15188 0Z",
  id: "Vector",
  fill: "#FFD300",
  fillRule: "evenodd",
  stroke: "none"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(0.038085938 6.373047)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.78856 1.16262C9.68881 1.23115 9.576 1.2648 9.462 1.2648C9.348 1.2648 9.23519 1.23115 9.13544 1.16262L7.45512 0L0 4.94829C0.0914375 5.54019 0.559312 6 1.1495 6L17.7745 6C18.3647 6 18.8326 5.54019 18.924 4.94829L11.4689 0.00124542L9.78856 1.16262Z",
  id: "Vector",
  fill: "#FFD300",
  fillRule: "evenodd",
  stroke: "none"
}))));

var SvgEmail = function SvgEmail(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "13px",
    viewBox: "0 0 19 13",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEmail, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/email.67664c62.svg";
export { ForwardRef as ReactComponent };